<template>
	<div>
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item>能耗分析</el-breadcrumb-item>
			<el-breadcrumb-item>横向对比分析</el-breadcrumb-item>
		</el-breadcrumb>
		<!-- 搜索筛选 -->
		<el-form :inline="true" :model="formInline" class="user-search" @submit.native.prevent>
			<el-form-item label="统计对象：">
				<el-popover v-model="visible">
					<el-input ref="deptInput" class="cp" readonly slot="reference" autosize size="small"  placeholder="选择部门/集中器"
					 v-model="getJZ"></el-input>
					<div >
						<el-tree v-loading="treeLoad" :data="treeDate" :expand-on-click-node="false" :highlight-current="true" ref="tree"
						 @node-click="handleNodeClick" :props="jzProps" accordion node-key='id' show-checkbox @check="checkTerIds">
							<span class="custom-tree-node" slot-scope="{ node, data }">
								<span>
									<i v-if="!data.parentId && !data.isJz" class="el-icon-office-building"></i>
									<i v-if="data.parentId" class="el-icon-location-outline"></i>
									<i v-if="data.isJz" class="el-icon-coin"></i>
									{{ data.departmentName }}
								</span>
							</span>
						</el-tree>
					</div>
				</el-popover>
			</el-form-item>
      <el-form-item label="比较对象：">
        <el-select size="small" v-model="t2ids" placeholder="请选择" :multiple-limit='4' clearable @change="getBjIds" multiple collapse-tags style="width: 280px;">
          <el-option
            v-for="item in dbData"
            :key="item.id"

            :label="item.departmentName"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item >
        <el-select size="small" v-model="formInline.energyType" style="width: 120px;" placeholder="请选择"  @change="getData">
          <el-option
            v-for="item in energyType"
            :key="item.id"
            :label="item.value"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select size="small" v-model="formInline.dateType"  style="width: 120px;"  @change="getDateType" >
          <el-option
            v-for="item in dateList"
            :key="item.value"
            :label="item.lable"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
         <el-date-picker
            @change="getData"
            style="width: 120px;"
            v-if="formInline.dateType == 'day'"
            size="small"
            value-format="yyyy-MM"
            v-model="formInline.monthDate"
            type="month"
            placeholder="选择月">
         </el-date-picker>
         <el-date-picker
            style="width: 120px;"
             @change="getData"
            v-if="formInline.dateType == 'month'"
            size="small"
            value-format="yyyy"
            v-model="formInline.yearDate"
            type="year"
            placeholder="选择年">
         </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button :disabled="nRefresh" type="primary" size="small" @click="Refresh">刷新</el-button>
      </el-form-item>
		</el-form>

		<!--列表-->
		<div class="paybox">
		  <div class="cavasbox" ref="fengLei"></div>
		</div>

    <el-table size="small" :data="dataList"  highlight-current-row  :header-cell-style="this.$store.state.headerCss" v-loading="loading" border element-loading-text="拼命加载中">
      <el-table-column  label="用能单元" prop="name" width="240"  fixed="left">
      </el-table-column>
      <el-table-column :label="t_title" >
        <el-table-column align="center" :label="item.value"  :prop="item.port" v-for="item in dataCol" min-width="120"></el-table-column>
      </el-table-column>

    </el-table>

	</div>
</template>

<script>
  import Chart from 'echarts'
	import { findEnergyRecordLandscape } from '../../api/analysisMG'
  import {getDepartmentTerminalInfoLis,getTerminalInfoByDepId} from '../../api/energyMG'
	export default {
		data(){
			return{
				leftDataList:[],
        leftDataCol:[],
        dataList:[],
        dataCol:[],
        nRefresh:false,
				formInline:{
					dateType:'day',
				  monthDate:new Date().getFullYear() + '-' +( new Date().getMonth()+1 < 10 ? '0':'' ) + (new Date().getMonth()+1),
					yearDate:"",
					terIds1:"",
          terIds2:"",
          energyType:15,
          departmentName:"",
				},
        depId:'',
        tableHeight: 0,
        dateList:[
          { value:'day',lable:'逐日' },
          { value:'month',lable:'逐月' },
        ],
        typeList:[
          { value:15,label:'电'},
          { value:16,label:"水"}
        ],
        t2ids:[],
        t_title: new Date().getFullYear() + '-' +( new Date().getMonth()+1 < 10 ? '0':'' ) + (new Date().getMonth()+1),
        getJZ:"",
        visible:false,
        loading:false,
        tableLabel:[],
        treeLoad:false,
        treeDate:[],
        dbData:[],
        energyType:[],
        jzProps: {
        	label: "departmentName",
        	children: 'deps'
        },
        user:{}

			}
		},
		created(){

      this.user = JSON.parse(sessionStorage.getItem('userdata'))

      this.getJzData().then( res => {

        this.formInline.terIds1 = this.getTepIds(res[0].id)
        this.getJZ = res[0].departmentName
        this.getData()
      });
      this.$store.dispatch('getEnergyTypeConfig').then( (res) => {
      	this.energyType = res
      })
		},
    mounted() {
    	this.$nextTick(() => {this.tableHeight = window.innerHeight - 175-30})
    },
		methods:{
			search(){

			},
      //获取比较对象的ids
      getBjIds(){

      },

      getDateType(e){
       if(e == 'day'){
         let dateStr = new Date().getFullYear() + '-' +( new Date().getMonth()+1 < 10 ? '0':'' ) + (new Date().getMonth()+1)
          this.t_title = dateStr
         this.formInline.dateType = 'day'
         this.formInline.monthDate = dateStr
         this.formInline.yearDate = ''
       }else if( e == 'month'){

          this.formInline.dateType = 'month'
          this.formInline.monthDate = ''
          this.formInline.yearDate = new Date().getFullYear()+''
          this.t_title = new Date().getFullYear()+''
       }

        this.getData()

      },
      Refresh(){
        this.getData()

      },
			getData(){
        this.loading = true
        this.formInline.departmentName = this.getJZ
        this.formInline.terIds2 = this.t2ids.join(',')
        this.t_title = this.formInline.monthDate || this.formInline.yearDate
				findEnergyRecordLandscape(this.formInline).then(res => {
          this.loading = false
					if(res.status == 1){
           let stemp = []
           let dtemp = []
           let legendame= [res.data.left.departmentName]
           //echars先加左边

           stemp.push({
             name: res.data.left.departmentName,
             type: 'bar',
             data: res.data.left.leftEchartList,
           })

           //table先加左边数据
           dtemp.push(
             res.data.left.leftDataArr[0]
           )

           if(res.data.rightObj.echartsData){
             res.data.rightObj.echartsData.forEach(item => {
               legendame.push(item.name)
               let s = {
                 	name: item.name,
                 	type: 'bar',
                 	data: item.data,
               }
               stemp.push(s)
             })
           }

           if(res.data.rightObj.dataList){
            res.data.rightObj.dataList.forEach(item => {
              dtemp.push(item)
            })
           }
           this.dataList = dtemp
           this.dataCol = res.data.headerArr

           console.log(this.dataList)

           let option = {
            tooltip: {
              trigger: 'axis'
            },
            legend: {
              data: legendame,
            },
            grid: {
              left: '3%',
              right: '4%',
              bottom: '3%',
              containLabel: true
            },
            toolbox: {
              show: true,
              feature: {
                mark: {
                  show: true
                },
                dataView: {
                  show: true,
                  readOnly: false
                },
                magicType: {
                  show: true,
                  type: ['line', 'bar'],
                },
                restore: {
                  show: true
                },
                saveAsImage: {
                  show: true
                }
              }
            },
            calculable: true,
            xAxis: [{
              type: 'category',
              data: res.data.echart
            }],
            yAxis: [{
              type: 'value',
            }],
            series: stemp
           }
            this.chart = Chart.init(this.$refs.fengLei)
            this.chart.setOption(option,true)
          }
				})
			},
      //设置动态表头
      setTableCol(){
        let l = 0
        let arr = []
        console.log(formInline.dateType)
        if( this.formInline.dateType == 'day'){
          let y = this.formInline.monthDate.substring(0,4)
          let m = this.formInline.monthDate.substring(5)

          l = new Date(y,m,0).getDate()
        }else if( this.formInline.dateType == 'month'){
          l = 12
        }else{
          console.log(Object.keys(this.dataList[0]))
          l = Object.keys(this.dataList[0]).length - 2
        }

        if( this.formInline.dateType == 'year'){
          var Year = 2019
          for( let i = 0;i< l ;i++){
            let obj = {}
            obj.lable = Year + ''
            obj.props = 'dateTime'+Year
            arr.push(obj)
            Year++
          }
        }else{
          for( let i =0;i< l;i++){
            let obj = {}
            obj.lable = (i+1)+''
            obj.props = i < 9 ? 'dateTime0'+(i+1) : 'dateTime'+(i+1)
            arr.push(obj)
          }
        }
        this.tableLabel = arr
      },

      //获取集中器信息
      getJzData: function() {
      	return new Promise((resolve, reject) => {
      		getDepartmentTerminalInfoLis().then(res => {
      			this.treeLoad = false
      			if (res.status == 1) {
      				this.treeDate = this.changeData(res.data.menuDepList)
              resolve(this.treeDate)
      			} else {
      				this.$message.error(res.msg)
      			}
      		})
      	})

      },
      changeData(data) {
      	data.forEach(item => {
      		if (item.terminalInfo) {
      			if (!item.deps) {
      				item.deps = []
      			}
      			item.terminalInfo.forEach(sitem => {
      				let obj = {}
      				obj.id = sitem.id
              obj.pid = item.id
              obj.pname = item.departmentName
      				obj.departmentName = sitem.terminalName
      				obj.terminalCode = sitem.terminalCode
      				obj.isJz = true
      				item.deps.push(obj)
      			})
      		}
      		if (item.deps) {
      			this.changeData(item.deps)
      		}
      	})
      	return data
      },

      checkTerIds(data, checked){
        //选择部门
        if(!data.isJz){


          if( this.depId != data.id ){
            this.$refs.tree.setCheckedKeys([]);
            this.$refs.tree.setCheckedKeys([data.id]);
          }
          this.depId = data.id
          this.getJZ = data.departmentName
          this.formInline.terIds1 = this.getTepIds(data.id)
        }else{  //选择集中器
          if( data.pid != this.depId ){
            this.$refs.tree.setCheckedKeys([data.id]);
          }


          this.depId = data.pid
          this.getJZ = data.pname

          let ids = []
          this.$refs.tree.getCheckedNodes().forEach(item => {
            if(item.isJz){
              ids.push(item.id)
            }
          })

          this.formInline.terIds1 = ids.join(',')
          this.getTepIds(data.pid)

        }
        this.t2ids = []
      },

      // getTerIdsOnLine(id){
      //   getTerminalInfoByDepId({
      //   	depId: id
      //   }).then(res => {
      //   	if (res.status == 1) {
      //       console.log(res)
      //   	} else {
      //   		this.$message.error(res.msg)
      //   	}
      //   })
      // },

      getTepIds(id){
        // 点击部门获得集中器id
        let tmep = []
        this.treeDate.forEach(item => {
          if(item.id == id){
            this.dbData = item.deps
            tmep = item.deps
          }
        })
        return tmep.map(item => item.id).join(',')

      },
      handleNodeClick(data) {

       //  if (data.isJz) {
       //    this.formInline.terId = data.id
       //    this.formInline.departmentId = ""
       //    this.getJZ = data.pname
       //  } else {
       //    this.formInline.terId = ""
       //    this.formInline.departmentId = data.id
       //    this.getJZ = data.departmentName
       //  }
       // //  this.getData()
      	// this.visible = false

      },

      rowClass(){
        return "color:#5c5c5c;background:#fff"
      },



		}
	}



</script>

<style>
  .el-tree-node.is-expanded>.el-tree-node__children{
     max-height: 360px;
     overflow: auto;
   }
   .paybox {
   	width: 100%;
   	background-color: #fff;
   	box-sizing: border-box;
   	border-radius: 5px;
     overflow: hidden;
   	height: 340px;
    margin-bottom: 30px;
   }
   .cavasbox {
   	box-sizing: border-box;
   	width: 100%;
   	height: 100%;
   }
</style>



// WEBPACK FOOTER //
// src/views/analysis/horizontalData.vue